import React from 'react';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import { Checkbox, FormControlLabel, CheckboxProps } from '@mui/material';

type checkBox = {
  type: 'checkbox';
  name: string;
  label: string | React.ReactNode;
  rule?: RegisterOptions;
  formControlLabelProps?: {};
  checkboxprops?: {};
};

type CheckboxPartialProps = Omit<CheckboxProps, keyof checkBox>;

export type CustomCheckBoxProp = checkBox & CheckboxPartialProps;

const CustomCheckBox: React.FC<checkBox & CheckboxPartialProps> = ({
  name,
  label,
  rule,
  formControlLabelProps,
  ...checkboxprops
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rule}
      render={({ field, fieldState }) => (
        <FormControlLabel
          {...formControlLabelProps}
          label={label}
          control={<Checkbox {...field} {...checkboxprops} checked={field.value} />}
        />
      )}
    />
  );
};

export default CustomCheckBox;
